import iconlogo from "./../../../assets/logore.png";
import ErrorBoundary from "../../../components/ErrorBoundary";
import { RestablecerPass } from "../../../model/Endpoints";
import ConfirmLogout from "../../../utilities/ConfirmLogout";
import {
  Layout,
  Menu,
  Button,
  Typography,
  Tooltip,
  Avatar,
  Modal,
  Drawer,
  Dropdown,
  ConfigProvider,
  Switch,
  Divider,
  App,
  theme,
} from "antd";
import { AntdStaticHelper } from "../../../utils/antdStatic";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  HomeOutlined,
  CompassOutlined,
  SafetyOutlined,
  CustomerServiceOutlined,
  PoweroffOutlined,
  PhoneOutlined,
  MailOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { items } from "./ListItems";
import { useSelector } from "react-redux";
import useTour from "../../../hooks/useTour";
import { useAppTheme } from "../../../context/ThemeContext";

const { Header, Sider, Content, Footer } = Layout;
const { Title, Text } = Typography;

/* ── Avatar dinámico ──────────────────────────────────── */
const AVATAR_PALETTE = ["#2596be","#20a080","#7c5cbf","#d97706","#c0392b","#3b73d4","#e67e22"];
const getInitials = (name = "") => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return parts.length === 1
    ? parts[0][0].toUpperCase()
    : (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
const getAvatarColor = (name = "") => {
  let h = 0;
  for (const c of name) h = (h << 5) - h + c.charCodeAt(0);
  return AVATAR_PALETTE[Math.abs(h) % AVATAR_PALETTE.length];
};

/* ── Paleta ───────────────────────────────────────────── */
const P       = "#2596be";
const P_DARK  = "#1a7a9e";
const P_MID   = "#4aadcc";
const P_PALE  = "#e0f4fb";
const P_ULTRA = "#f0f8fc";

const lightTokens = {
  colorPrimary:       P,
  colorPrimaryHover:  P_DARK,
  borderRadius:       10,
  fontFamily:         "'Plus Jakarta Sans', sans-serif",
  colorBgLayout:      P_ULTRA,
  colorBgContainer:   "#ffffff",
  colorBgElevated:    "#ffffff",
  colorBorder:        "#c8e8f2",
  colorText:          "#1a3a4a",
  colorTextSecondary: "#5c8fa0",
};

const darkTokens = {
  colorPrimary:       P_MID,
  colorPrimaryHover:  P,
  borderRadius:       10,
  fontFamily:         "'Plus Jakarta Sans', sans-serif",
  colorBgLayout:      "#0b1929",
  colorBgContainer:   "#122333",
  colorBgElevated:    "#1a3044",
  colorBorder:        "#1e3d52",
  colorText:          "#d0eaf5",
  colorTextSecondary: "#7aafca",
};

const lightComponents = {
  Menu: {
    itemSelectedBg:    P_PALE,
    itemSelectedColor: P,
    itemHoverBg:       P_ULTRA,
    itemHoverColor:    P,
    subMenuItemBg:     "#f8fcfe",
  },
  Layout: { siderBg: "#ffffff", headerBg: "#ffffff", footerBg: "#ffffff" },
};

const darkComponents = {
  Menu: {
    itemSelectedBg:    "#1a3a4a",
    itemSelectedColor: P_MID,
    itemHoverBg:       "#152d3d",
    itemHoverColor:    P_MID,
    subMenuItemBg:     "#0f2232",
  },
  Layout: { siderBg: "#0d1e2c", headerBg: "#0d1e2c", footerBg: "#0d1e2c" },
};

/* ───────────────────────────────────────────────────────── */

const DashboardPrestTemp = () => {
  const { nombreCompleto, codigoAfiliado } = useSelector((state) => state.user);

  const { isDark: isDarkMode, toggle: handleThemeChange } = useAppTheme();

  const location = useLocation();
  const [current, setCurrent]       = useState("");
  const [collapsed, setCollapsed]   = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openKeys, setOpenKeys]     = useState(["sub1"]);

  useEffect(() => {
    const path = location.pathname;
    const found = items
      .flatMap((i) => i.children || [])
      .find((c) => typeof c.label?.props?.to === "string" && c.label.props.to === path);
    if (found) {
      setCurrent(found.key);
      setOpenKeys(
        ["1","2","3","4","5","6","7","8","9","10"].includes(found.key) ? ["sub1"] : ["sub2"]
      );
    }
  }, [location]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const { HandleConfirmLogout }       = ConfirmLogout();

  const HandleActivatedTour = useTour([
    { element: "#home",       intro: "Bienvenido a nuestra oficina virtual.", position: "center" },
    { element: "#toolbar",    intro: "Aquí ves tu nombre y código de prestador." },
    { element: "#switch",     intro: "Cambia entre tema claro y oscuro." },
    { element: "#botonhome",  intro: "Regresa a la pantalla principal." },
    { element: "#nombreprest",intro: "Tu nombre completo como prestador." },
    { element: "#codigoprest",intro: "Tu código de prestador." },
    { element: "#resetpass",  intro: "Cambia tu contraseña aquí." },
    { element: "#contact",    intro: "Centro de contacto con nuestros canales de atención." },
    { element: "#logout",     intro: "Cierra tu sesión de forma segura." },
    { element: "#sidebar",    intro: "Menú con todas tus opciones disponibles." },
    { element: "#menuhidden", intro: "Expande u oculta el menú." },
    { element: "#menuitems",  intro: "Haz click en la flecha para ver las opciones." },
  ]);

  const avatarMenu = {
    items: [{
      key: "1",
      label: (
        <div style={{ textAlign: "center", padding: "4px 0" }}>
          <Title level={5} style={{ margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 700 }}>
            {nombreCompleto}
          </Title>
          <Text type="secondary" style={{ fontSize: 12 }}>{codigoAfiliado}</Text>
        </div>
      ),
    }],
  };

  const headerBorder = isDarkMode ? "0 1px 0 #1e3d52" : "0 1px 4px rgba(37,150,190,0.08)";
  const siderBorder  = isDarkMode ? "1px solid #1e3d52" : "1px solid #e0f4fb";

  return (
    <ConfigProvider
      theme={{
        algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: isDarkMode ? darkTokens : lightTokens,
        components: isDarkMode ? darkComponents : lightComponents,
      }}
    >
      <App>
        <AntdStaticHelper />
      <Layout style={{ minHeight: "100vh" }}>

        {/* ── Sidebar escritorio ─────────────────────── */}
        <Sider
          id="sidebar"
          trigger={null}
          collapsible
          collapsed={collapsed}
          width={260}
          collapsedWidth={0}
          onBreakpoint={(broken) => { if (broken) setCollapsed(true); }}
          style={{ display: window.innerWidth < 992 ? "none" : "block", borderRight: siderBorder }}
        >
          <div style={{ padding: "18px 16px 14px", display: "flex", justifyContent: "center", borderBottom: isDarkMode ? "1px solid #1e3d52" : "1px solid #e0f4fb", marginBottom: 4 }}>
            <img
              src={iconlogo}
              alt="ARS Renacer"
              style={{ width: 130, height: "auto", filter: isDarkMode ? "brightness(0) invert(1)" : "none", transition: "filter 0.3s" }}
            />
          </div>
          <Menu
            id="menuitems"
            mode="inline"
            items={items}
            selectedKeys={[current]}
            openKeys={openKeys}
            onOpenChange={(keys) => setOpenKeys(keys)}
            style={{ border: "none", paddingTop: 4 }}
          />
        </Sider>

        {/* ── Drawer móvil ───────────────────────────── */}
        <Drawer placement="left" closable={false} onClose={() => setOpenDrawer(false)} open={openDrawer} styles={{ body: { padding: 0 } }} width={260}>
          <div style={{ padding: "18px 16px 14px", borderBottom: "1px solid #e0f4fb", marginBottom: 4 }}>
            <img src={iconlogo} alt="ARS Renacer" style={{ width: 120, height: "auto" }} />
          </div>
          <Menu mode="inline" selectedKeys={[current]} items={items} style={{ border: "none" }} />
        </Drawer>

        <Layout>
          {/* ── Header ─────────────────────────────────── */}
          <Header style={{ padding: "0 16px 0 0", display: "flex", alignItems: "center", justifyContent: "space-between", boxShadow: headerBorder, position: "sticky", top: 0, zIndex: 100 }}>
            <Button
              id="menuhidden"
              type="text"
              icon={window.innerWidth < 992 ? <MenuUnfoldOutlined /> : collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => window.innerWidth < 992 ? setOpenDrawer(true) : setCollapsed(!collapsed)}
              style={{ fontSize: 16, width: 56, height: 56 }}
            />

            {/* Info usuario — desktop */}
            <div id="toolbar" style={{ display: window.innerWidth < 992 ? "none" : "flex", alignItems: "center", gap: 10 }}>
              <Avatar
                style={{ backgroundColor: getAvatarColor(nombreCompleto), flexShrink: 0, fontWeight: 700, fontSize: 13 }}
                size={32}
              >
                {getInitials(nombreCompleto)}
              </Avatar>
              <div style={{ lineHeight: 1.25 }}>
                <Title id="nombreprest" level={5} style={{ margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 600, fontSize: 13 }}>
                  {nombreCompleto}
                </Title>
                <Text id="codigoprest" type="secondary" style={{ fontSize: 11 }}>{codigoAfiliado}</Text>
              </div>
            </div>

            {/* Acciones — desktop */}
            <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
              <div style={{ display: window.innerWidth < 992 ? "none" : "flex", alignItems: "center", gap: 2 }}>
                <Tooltip title="Instructivo">
                  <Button type="text" icon={<CompassOutlined style={{ fontSize: 17, color: P }} />} onClick={HandleActivatedTour} style={{ borderRadius: 10 }} />
                </Tooltip>
                <Switch id="switch" checkedChildren="🌙" unCheckedChildren="☀️" checked={isDarkMode} onChange={handleThemeChange} style={{ margin: "0 4px" }} />
                <Divider type="vertical" style={{ height: 20, margin: "0 2px" }} />
                <Tooltip title="Inicio">
                  <NavLink to="/dashboardpres">
                    <Button id="botonhome" type="text" icon={<HomeOutlined style={{ fontSize: 17, color: P }} />} style={{ borderRadius: 10 }} />
                  </NavLink>
                </Tooltip>
                <Tooltip title="Restablecer contraseña">
                  <a href={`${RestablecerPass}/Inicio/Restablecer`} target="_blank" rel="noreferrer">
                    <Button id="resetpass" type="text" icon={<SafetyOutlined style={{ fontSize: 17, color: "#20a080" }} />} style={{ borderRadius: 10 }} />
                  </a>
                </Tooltip>
                <Tooltip title="Contacto">
                  <Button id="contact" type="text" icon={<CustomerServiceOutlined style={{ fontSize: 17, color: "#d97706" }} />} onClick={() => setIsModalOpen(true)} style={{ borderRadius: 10 }} />
                </Tooltip>
                <Divider type="vertical" style={{ height: 20, margin: "0 2px" }} />
                <Tooltip title="Cerrar sesión">
                  <Button id="logout" type="text" danger icon={<PoweroffOutlined style={{ fontSize: 17 }} />} onClick={HandleConfirmLogout} style={{ borderRadius: 10 }} />
                </Tooltip>
              </div>

              {/* Acciones — móvil */}
              <div style={{ display: window.innerWidth < 992 ? "flex" : "none", alignItems: "center", gap: 4 }}>
                <Switch id="switch" checkedChildren="🌙" unCheckedChildren="☀️" checked={isDarkMode} onChange={handleThemeChange} />
                <Dropdown menu={avatarMenu} trigger={["click"]} placement="bottomRight">
                  <Avatar
                  style={{ backgroundColor: getAvatarColor(nombreCompleto), cursor: "pointer", fontWeight: 700, fontSize: 13 }}
                >
                  {getInitials(nombreCompleto)}
                </Avatar>
                </Dropdown>
                <Button type="text" danger id="logout" icon={<PoweroffOutlined style={{ fontSize: 17 }} />} onClick={HandleConfirmLogout} />
              </div>
            </div>
          </Header>

          {/* ── Contenido ─────────────────────────────── */}
          <Content style={{ margin: "20px 16px 0", padding: "0 4px", minHeight: 280 }}>
            <ErrorBoundary inline>
              <Outlet />
            </ErrorBoundary>
          </Content>

          {/* ── Footer ────────────────────────────────── */}
          <Footer style={{ textAlign: "center", borderTop: isDarkMode ? "1px solid #1e3d52" : "1px solid #e0f4fb", padding: "12px 24px", fontSize: 12, color: isDarkMode ? "#7aafca" : "#8cb4c3", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            ARS RENACER ©{new Date().getFullYear()}
          </Footer>
        </Layout>

        {/* ── Modal de contacto ──────────────────────── */}
        <Modal
          title={
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ width: 32, height: 32, borderRadius: 8, background: isDarkMode ? "#1e3d52" : P_PALE, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <CustomerServiceOutlined style={{ color: P, fontSize: 15 }} />
              </div>
              <span style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 600, fontSize: 15, color: isDarkMode ? "#d0eaf5" : undefined }}>Centro de Contacto</span>
            </div>
          }
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={null}
          width={340}
          styles={{
            content: { background: isDarkMode ? "#122333" : "#ffffff" },
            body:    { background: isDarkMode ? "#122333" : "#ffffff" },
            header:  { background: isDarkMode ? "#122333" : "#ffffff" },
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 10, paddingTop: 8 }}>
            {[
              { icon: <PhoneOutlined style={{ color: P, fontSize: 17 }} />,            bg: isDarkMode ? "#1e3d52" : P_PALE,    label: "809-621-9999" },
              { icon: <MailOutlined  style={{ color: P, fontSize: 17 }} />,             bg: isDarkMode ? "#1e3d52" : P_PALE,    label: "servicioalcliente@arsrenacer.com" },
              { icon: <WhatsAppOutlined style={{ color: "#25D366", fontSize: 17 }} />,  bg: isDarkMode ? "#0d2e1e" : "#e8faf0", label: "809-736-2237" },
            ].map(({ icon, bg, label }, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", borderRadius: 10, background: bg }}>
                {icon}
                <span style={{ fontSize: 13, fontWeight: 500, color: isDarkMode ? "#d0eaf5" : undefined }}>{label}</span>
              </div>
            ))}
          </div>
        </Modal>

      </Layout>
      </App>
    </ConfigProvider>
  );
};

export default DashboardPrestTemp;
